import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-current-date',
  templateUrl: './current-date.component.html',
  styleUrls: ['./current-date.component.css'],
})
export class CurrentDateComponent implements OnInit {
  @Input() inputdate: string | undefined;

  CurrentDate: any;
  constructor() {}

  ngOnInit() {
    if (this.inputdate == '')
      this.CurrentDate = moment().format('dddd, MMMM Do YYYY');
    else this.CurrentDate = moment(this.inputdate).format('dddd, MMMM Do YYYY');
  }
}
